export default {
  getScrollLeft: function (doc) {
    var _doc = doc || document;
    return _doc.body.scrollLeft;
  },
  getScrollTop: function (doc) {
    var _doc = doc || document;
    return _doc.body.scrollTop;
  },
  getClientHeight: function (doc) {
    var _doc = doc || document;
    return _doc.compatMode == "CSS1Compat" ? _doc.documentElement.clientHeight || cacheHeight : _doc.body.clientHeight;
  },
  getClientWidth: function (doc) {
    var _doc = doc || document;
    return _doc.compatMode == "CSS1Compat" ? _doc.documentElement.clientWidth : _doc.body.clientWidth;
  }
};
